import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getFromObject } from '@endurancewarranty/lib';
import { AgentSessionEventEnum, AgentStatusEnum, SoftphoneConnectionBehaviorEnum } from '@lib/enums';
import { useJotaiValue, useSetJotaiAtom } from '@states/jotai/hooks';
import { currentCallAtom } from '@states/softphone/currentCallAtom';
import { INITIAL_SOFTPHONE_STATE, softphoneAtom } from '@states/softphone/softphoneAtom';
import type { TAgentSessionEvents } from '@models/contacts/sessions/TAgentSessionEvents';
export function useApplySoftphoneSession(session) {
  const $ = _c(8);
  const {
    connectionBehavior
  } = useJotaiValue(softphoneAtom);
  const {
    lastRoutedContactId
  } = useJotaiValue(currentCallAtom);
  const setSoftphoneState = useSetJotaiAtom(softphoneAtom);
  let t0;
  if ($[0] !== session || $[1] !== setSoftphoneState) {
    t0 = () => {
      if (session == null) {
        return;
      }
      const events = session.events.sort(_temp);
      const latestDisconnectEvent = events?.findLast(_temp2);
      if (latestDisconnectEvent != null && latestDisconnectEvent.eventType === AgentSessionEventEnum.Disconnected) {
        setSoftphoneState({
          ...INITIAL_SOFTPHONE_STATE,
          connectionBehavior: SoftphoneConnectionBehaviorEnum.OptIn,
          agentStatus: AgentStatusEnum.Disconnected
        });
        return;
      }
      const latestStateEvent = events?.findLast(_temp3);
      if (latestStateEvent != null && latestStateEvent.eventType === AgentSessionEventEnum.StateEvent) {
        const agentStatus = getFromObject(AgentStatusEnum, latestStateEvent.currentState) ?? AgentStatusEnum.Unavailable;
        const newAgentStatus = latestStateEvent.isAcw === true ? AgentStatusEnum.Acw : agentStatus;
        setSoftphoneState(currentState => ({
          ...currentState,
          agentStatus: newAgentStatus
        }));
      }
      const latestCallEvent = events?.findLast(_temp4);
      if (latestCallEvent != null && latestCallEvent.eventType === AgentSessionEventEnum.CallContactEvent) {
        setSoftphoneState(currentState_0 => ({
          ...currentState_0,
          contactId: latestCallEvent.contactId,
          contactMasterId: latestCallEvent.contactMasterId,
          contactPhoneNumber: latestCallEvent.contactPhoneNumber,
          channel: latestCallEvent.channel,
          callDirection: latestCallEvent.callDirection,
          leadId: latestCallEvent.leadId,
          transferType: latestCallEvent.transferType,
          transferConsumerId: latestCallEvent.transferConsumerId,
          transferQuoteId: latestCallEvent.transferQuoteId,
          transferHomeQuoteId: latestCallEvent.transferHomeQuoteId,
          transferContractId: latestCallEvent.transferContractId,
          requestedOdometer: latestCallEvent.requestedOdometer,
          isVoicemail: latestCallEvent.isVoiceMail,
          isDialerReturn: latestCallEvent.isDialerReturn,
          isInternetResponder: latestCallEvent.isInternetResponder,
          isTvResponder: latestCallEvent.isTvResponder,
          isSpanishSkillActive: latestCallEvent.isSpanishSkillActive,
          isWelcomeWagon: latestCallEvent.isWelcomeWagon,
          sessionId: session.sessionId,
          isSimulatedCall: false
        }));
      }
    };
    $[0] = session;
    $[1] = setSoftphoneState;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== connectionBehavior || $[4] !== lastRoutedContactId || $[5] !== session || $[6] !== setSoftphoneState) {
    t1 = [connectionBehavior, lastRoutedContactId, session, setSoftphoneState];
    $[3] = connectionBehavior;
    $[4] = lastRoutedContactId;
    $[5] = session;
    $[6] = setSoftphoneState;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
}
function _temp4(event_1) {
  return event_1.eventType === AgentSessionEventEnum.CallContactEvent;
}
function _temp3(event_0) {
  return event_0.eventType === AgentSessionEventEnum.StateEvent;
}
function _temp2(event) {
  return event.eventType === AgentSessionEventEnum.Disconnected;
}
function _temp(a, b) {
  return a.eventDateTimeUtc != null && b.eventDateTimeUtc != null ? new Date(a.eventDateTimeUtc).valueOf() - new Date(b.eventDateTimeUtc).valueOf() : 0;
}